export const findWebGL = () => {
  const canvas = document.createElement('canvas')
  let gl
  let debugInfo
  let renderer

  try {
    gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
  } catch (e) {
    return
  }

  if (gl) {
    debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
    renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
  }
  return renderer
}
